import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { Address, Dependent } from '../../../user/models/user-profile.model';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';

@Component({
  selector: 'app-ambulance-international',
  imports: [
    FormsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    CommonModule
  ],
  templateUrl: './ambulance-international.component.html',
  styleUrl: './ambulance-international.component.scss',
})
//Este componente no se esta utilizando actualmente solo se usa ambulancia-assistance
export class AmbulanceInternationalComponent implements OnInit, AfterViewInit {
  @Input() nameService: string = '';
  @Input() currentMapLocation: any = null;
  @Input() isLoadingLocation: boolean = false;
  @Input() showMapSearchInput: boolean = false;
  @Input() set mapMovedManually(moved: boolean) {
    if (moved) {
      this.selectedAddress = null;
    }
  }
  @Output() addressSelected = new EventEmitter<any>();
  @Output() enableMapSearch = new EventEmitter<void>();
  @Output() disableMapSearch = new EventEmitter<void>();
  @Output() searchAddress = new EventEmitter<string>();
  
  isEditingCurrentLocation: boolean = false;
  isSearching: boolean = false;
  
  @ViewChild('searchInput') searchInput: any;
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  addresses: Address[] = [];
  dependent: Dependent[] = [];
  hideHeader = false;
  showAllAddresses = false;
  selectedAddress: any = null;
  selectedPatient = 'titular';
  reference: string = '';
  userProfile: any;
  contactoDeTelefono: String = '0';

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const clSubServicio = parseInt(this.route.snapshot.queryParams['clSubServicio']);
      const serviceContact = contacts.find((c: any) => c.clSubServicio === clSubServicio);
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  // Cuentas permitidas para ambulancia internacional
  private allowedAccounts = [2228, 2665, 2559, 2907];

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private requestServ: RequestsService, private loader: LoaderService) { }

  ngOnInit() {
    // Verificar si la cuenta actual está permitida
    if (!this.isAccountAllowed()) {
      console.error('Cuenta no autorizada para Ambulancia Internacional');
      this.router.navigate(['/home']);
      return;
    }

    // Solo obtener de la ruta si no se pasó como Input
    if (!this.nameService) {
      this.nameService = this.route.snapshot.paramMap.get('nombre') || '';
    }
    this.hideHeader = this.route.snapshot.queryParamMap.get('hideHeader') === 'true';
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
    }
    this.getServiceContact();
    this.getDetailUser();
  }

  private isAccountAllowed(): boolean {
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : null;
    return this.allowedAccounts.includes(accountId);
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.userProfile = res;
          this.dependent = res.dependents;
          this.addresses = res.address;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  goToConfirm() {
    console.log("entre a save ambulancia internacional");
    console.log('selectedAddress:', this.selectedAddress);
    console.log('currentMapLocation:', this.currentMapLocation);
    
    setTimeout(() => this.loader.show(), 0);    
    const selectedName = this.selectedPatient === 'titular'
      ? this.nameOwner
      : this.selectedPatient;

    const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
    
    // Obtener accountId desde localStorage
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : 536;
    
    // Verificar nuevamente que la cuenta esté permitida
    if (!this.allowedAccounts.includes(accountId)) {
      this.loader.hide();
      console.error('Cuenta no autorizada para Ambulancia Internacional');
      return;
    }
    
    // Obtener coordenadas de la dirección seleccionada o ubicación actual
    let latitude = '';
    let longitude = '';
    
    if (this.selectedAddress && this.selectedAddress.lat && this.selectedAddress.lng) {
      // Si hay dirección seleccionada, usar sus coordenadas
      latitude = this.selectedAddress.lat.toString();
      longitude = this.selectedAddress.lng.toString();
    } else if (this.currentMapLocation && this.currentMapLocation.lat && this.currentMapLocation.lng) {
      // Si no hay dirección seleccionada, usar la ubicación actual del mapa
      latitude = this.currentMapLocation.lat.toString();
      longitude = this.currentMapLocation.lng.toString();
    }
    console.log(this.selectedAddress);
    
    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        serviceId: 6, // Asistencia en Viajes Internacional
        subServiceId: 241,
        hasAssistance: false,
        key: this.keyOwner,
        areaCode1: '044',
        phone1: this.phoneOwner,
        cp: this.selectedAddress?.cp || this.currentMapLocation?.postalCode || '',
        callenum: (this.selectedAddress?.streetNumber || this.currentMapLocation?.identifier || 'Ubicación actual').substring(0, 99),
        stateCode: this.selectedAddress?.codeent || this.currentMapLocation?.codeEstado?.id || this.currentMapLocation?.codeEstado || '',
        municipalityCode: this.selectedAddress?.codemun || this.currentMapLocation?.codeMunicipio?.id || this.currentMapLocation?.codeMunicipio || '',
        statusId: 0,
        accountId: accountId,
        appUserId: 1,
        countryId: 115,
        contactTypeId: 15,
        serviceTypeId: 1,
        sendCharge: false,
        hasAppointment: false,
        isRelevant: false,
        gender: 1,
        isOk: true,
        hasQuotation: false,
        isSise2: true,
        serviceReceptionId: 10,
        personId: 1,
        username: this.nameOwner,
        paternalSurname: '',
        userSecondLastName: '',
        contactName: this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient,
        userFirstNamePf: firstName,
        userLastNamePf: lastName,
        userSecondLastNamePf: secondLastName,
        ourUser: this.nameOwner,
        externalCabRepName: 'API CLIENTES',
        folio: crypto.randomUUID(),
        longitude: longitude,
        latitude: latitude,
        incidentDescription: this.reference
      }
    };
    console.log(payload);
    

    this.requestServ.sendAmbulanceRequest(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        console.log('Solicitud de ambulancia internacional enviada correctamente', res);
        
        // Navegar a la página de detalles con el expediente
        const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
        console.log('expediente:', expediente);
        
        // Crear objeto con los parámetros necesarios para queryParams
        const assistanceData = {
          clave: res.response.clave || '',
          clexpediente: expediente,
          nuestrousuario: res.response.nuestrousuario || this.nameOwner,
          clcuenta: res.response.clcuenta || '',
          nombre: 'AMBULANCIA INTERNACIONAL',
          clservicio: res.response.clservicio || '4',
          dsservicio: 'Asistencia en Viajes Internacional',
          clsubservicio: res.response.clsubservicio || '223',
          dssubservicio: 'Ambulancia Internacional',
          clestatus: res.response.clestatus || '0',
          dsestatus: 'Abierto',
          fecharegistro: res.response.fecharegistro || new Date().toISOString()
        };
        
        const navigationExtras: NavigationExtras = {
          state: assistanceData,
          queryParams: assistanceData
        };
        
        this.router.navigate(['/solicitud/detalle/', expediente], navigationExtras).then(() => {
          // Después de navegar, hacer la llamada automática con un pequeño delay
          setTimeout(() => {
            this.goToCall();
          }, 1000);
        });
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error al enviar solicitud de ambulancia internacional', err);
      }
    });
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(' ');
    return {
      firstName: parts[0] || '',
      lastName: parts[1] || '',
      secondLastName: parts.slice(2).join(' ') || ''
    };
  }

  goToCall() {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }

  toggleAddresses() {
    this.showAllAddresses = !this.showAllAddresses;
  }

  goToAddAddress() {
    this.router.navigate(['/add-direccion']);
  }
  selectAddress(dir: any) {
    console.log('Dirección seleccionada en ambulance internacional:', dir);
    this.selectedAddress = dir;
    
    // Si es ubicación actual, solo seleccionar sin habilitar buscador
    if (!dir.isCurrentLocation) {
      this.disableMapSearch.emit();
      this.isEditingCurrentLocation = false;
    }
    
    // Emitir la dirección seleccionada al componente padre
    if (dir.lat && dir.lng) {
      const addressData = {
        lat: parseFloat(dir.lat),
        lng: parseFloat(dir.lng),
        address: dir.isCurrentLocation ? 
          dir.identifier : 
          `${dir.colony}, ${dir.streetNumber}, ${dir.identifier}`
      };
      console.log('Emitiendo addressData:', addressData);
      this.addressSelected.emit(addressData);
    } else {
      console.log('No hay coordenadas en la dirección:', dir);
    }
  }

  ngAfterViewInit() {
    // Inicializar autocompletado cuando se abre la edición
  }

  onSearchInput(event: any) {
    const value = event.target.value;
    if (value && value.length > 2) {
      this.isSearching = true;
      this.searchAddress.emit(value);
    } else {
      this.isSearching = false;
    }
  }

  toggleEditCurrentLocation(event: Event) {
    event.stopPropagation();
    this.isEditingCurrentLocation = !this.isEditingCurrentLocation;
    
    if (this.isEditingCurrentLocation) {
      this.enableMapSearch.emit();
      // Inicializar autocompletado en el input integrado
      setTimeout(() => {
        this.initializeAutocomplete();
      }, 100);
    } else {
      this.disableMapSearch.emit();
      this.isSearching = false;
    }
  }

  initializeAutocomplete() {
    if (!this.searchInput || !this.searchInput.nativeElement) {
      return;
    }

    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      return;
    }

    try {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchInput.nativeElement,
        {
          types: ['establishment', 'geocode'],
        }
      );

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.isSearching = false;
        
        if (place && place.geometry && place.geometry.location) {
          const addressData = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            address: place.formatted_address || place.name || 'Ubicación seleccionada'
          };
          this.addressSelected.emit(addressData);
        }
      });
    } catch (error) {
      console.error('Error inicializando autocompletado:', error);
    }
  }  
}